export * from './index';

// VirtualSelect powers the merchandising recap's "Add additional product"
// picker (recapResponseForm component). The response/ and editor/ entrypoints
// already import this; the staff entry needs it too so the picker renders.
import 'virtual-select-plugin/dist/virtual-select.min.css';
import 'virtual-select-plugin/dist/virtual-select.min.js';
import { monkeyPatchForSingleArgumentConsoleLogs } from '../../lib/util';

// Actual bootstrap process here instead of using ng-app directive
// See: http://stackoverflow.com/a/27450072/72

angular.element(document).ready(() => {
  if (window.cordova) {
    console.info("Cordova detected; waiting for deviceready event before bootstrapping Angular");

    let isAndroid = /android/gi.test(navigator.userAgent);
    if (isAndroid) {
      monkeyPatchForSingleArgumentConsoleLogs();
    }

    document.addEventListener('deviceready', () => {
      console.info("deviceready");

      console.info("Bootstrapping Angular with Cordova");
      angular.bootstrap(document.body, ['staff']);
    })
  } else {
    console.info("Bootstrapping Angular without Cordova");
    angular.bootstrap(document.body, ['staff']);
  }
});
